export * from '@devcycle/openfeature-web-provider/strategy'
